module.exports = __webpack_public_path__ + "img/logo1.743fafc4.png";